module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"hurryUp":"Hurry up! promo available only until","discount":"Discount","finalPrice":"Final price: {price} USD","getNow":"Get Now!"},"es":{"hurryUp":"¡Apresúrate! promoción disponible hasta","discount":"Descuento","finalPrice":"Precio final: {price} USD","getNow":"Obtenlo ahora!"}}')
  delete Component.options._Ctor
}
